import { PlanDetailsPlanStatusEnum, PropChallengeChallengeStatusEnum } from 'services/generatedClientFromSwagger';

export const PropChallengeStatusEnum = {
    ...PropChallengeChallengeStatusEnum,
    ...PlanDetailsPlanStatusEnum,
};

export type PropChallengeStatusEnumType = PropChallengeChallengeStatusEnum | PlanDetailsPlanStatusEnum;
